import newBranchet from "./branchetFn";
import titleize from "underscore.string/titleize";
var _ = require("underscore.string");
var moment = require("moment");
var image1 = require("./logoOrdre");
import { renderRemuneration } from "./Remuneration";
moment.locale("fr");

export function renderContratEtudiant(contrat, pdf, stream) {
  console.log("contrat etudiant");
  var titulaire = contrat.titulaireByTitulaireId;
  var remplacant = contrat.remplacantByRemplacantId;
  var nomCompletTitulaire =
    titleize(titulaire.prenom) + " " + titulaire.nom.toUpperCase();

  var ilElle = function() {
    if (remplacant.salutation === "Madame") {
      return "elle";
    } else {
      return "il";
    }
  };
  pdf.image(image1.image(), 250, 40, { scale: 0.3 });
  pdf.moveDown(5);
  pdf.text("Contrat de remplacement en exercice libéral", { align: "center" });
  pdf.moveDown(1);
  pdf.text(
    "Articles R.4127-65 et  R.4127-91 du Code de la Santé publique (code de déontologie médicale) ) \nRemplacement par un(e) étudiant(e) en médecine titulaire d'une licence de remplacement  \nadopté le 9 février 1996\n MAJ oct.2008\nMAJ 10 septembre 2020",
    { align: "center" }
  );
  pdf.moveDown(3);
  pdf.text(
    "Entre \nla docteure / le docteur " +
      nomCompletTitulaire +
      "  (médecin anesthésiste, numéro  " +
      titulaire.ordre +
      ") exerçant à la Clinique des Cèdres 21 Rue Albert Londres 38130 Echirolles. \nd'une part\nEt " +
      "\nMadame / Monsieur" +
      titleize(remplacant.fullName) +
      "  ( " +
      remplacant.adresse +
      "), Immatriculé à l’URSSAF, sous le n° " +
      remplacant.urssaf +
      " d'autre part"
  );
  pdf.moveDown(1);
  pdf.text(
    "PREAMBULE \nDans le souci de respecter l'obligation déontologique qui est la sienne d'assurer la permanence des soins et conformément aux dispositions de l'article R.4127-65 du code de la santé publique (code de déontologie), la docteure / le docteur   " +
      nomCompletTitulaire +
      " a contacté Mme / Mr "  +
      titleize(remplacant.nom) +
      " ,régulièrement autorisé(e) en vertu de l'article L.4131-2 du code de la santé publique, pour prendre en charge, lors de la cessation temporaire de son activité professionnelle habituelle, les patients qui feraient appel à elle/lui.\nPour permettre le bon déroulement de ce remplacement, la docteure / le docteur  " +
      nomCompletTitulaire +
      "  met à la disposition de Mme / Mr " +
      titleize(remplacant.nom) +
      " son cabinet de consultations  sis 48 Avenue de Grugliasco 38130 Echirolles et son secrétariat."
  );
  pdf.text(
      "Mme / Mr   " +
      titleize(remplacant.nom) +
      " assume de ce fait toutes les obligations inscrites dans le code de déontologie; " +
      "Elle/il ne peut  aliéner son indépendance professionnelle sous quelque forme que ce soit. \nIl a été convenu  ce qui suit:"
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 1er\nDans le souci de la permanence  des soins, la docteure / le docteur  " +
      nomCompletTitulaire +
      " charge  Mme / Mr   " +
      titleize(remplacant.nom) +
      " qui accepte, de le remplacer temporairement auprès des patients qui feraient  appel  à elle/lui.\nLes patients devront être avertis, dès que possible, de la présence d'un(e) remplaçant(e) et notamment lors de toute demande de rendez-vous au cabinet médical.\n" +
      "Mme / Mr   " +
      titleize(remplacant.nom) +
      " doit consacrer à cette activité tout le temps nécessaire selon des modalités qu' elle/il fixe librement."
  );

  pdf.text(

      "Elle/Il s'engage à donner, à tout malade faisant appel à elle/lui, des soins consciencieux et attentifs dans le respect des dispositions du code de déontologie.\nHors le cas d'urgence, elle/il " +
      " peut, dans les conditions de l'article R.4127-47 du code de la santé publique (code de déontologie), refuser ses soins pour des raisons professionnelles ou personnelles."
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 2 \nLe présent contrat de remplacement est prévu pour une période de " +
      contrat.getCountDays +
      " jour(s) ,correspondant au(x) jour(s) suivant(s): " +
      contrat.setDatesFields +
      ".\nSon éventuel renouvellement est subordonné au respect des dispositions de l'article L.4131-2 du code de la santé publique."
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 3\nPendant la durée du présent contrat de remplacement et pour les besoins de son exécution, Mme / Mr " +
      _.titleize(remplacant.nom) +
      " a l'usage des locaux professionnels, installations et appareils que la docteure / le docteur  " +
      nomCompletTitulaire +
      " met à sa disposition.   " +
      "Elle / il doit en faire un usage raisonnable.\n Compte tenu du caractère par nature provisoire de l'activité du remplaçant/de la remplaçante, celle-ci/celui-ci s'interdit toute modification des lieux ou de leur destination."
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 4\n" +
      "Mme / Mr  " +
      _.titleize(remplacant.nom) +
      " exerce son art en toute indépendance.Elle/il est seul responsable vis-à-vis des patients et des tiers des conséquences de son exercice professionnel et conserve seul(e) la responsabilité de son activité professionnelle pour laquelle   " +
      "elle/il s'assure personnellement à ses frais à une compagnie notoirement solvable. " +
      "Elle / il doit apporter la preuve de cette assurance avant le début de son activité."
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 5\n" +
      "Mme / Mr  " +
      _.titleize(remplacant.nom) +
      " utilise conformément à la Convention nationale les ordonnances ainsi que les feuilles de soins et imprimés pré-identifiés au nom de la docteure / le docteur  " +
      nomCompletTitulaire +
      "  et/ou sa CPF dans son activité relative aux seuls patients de la docteure / le docteur  " +
      nomCompletTitulaire +
      ". En outre,   " +
      "elle/il doit faire mention de son identification personnelle sur les ordonnances, feuilles de soins et imprimés réglementaires qu'elle/il sera amené(e) à remplir."
  );
  pdf.moveDown(2);
  pdf.text(
    "Article 6\nLes deux co-contractants procédent à des déclarations fiscales et sociales indépendantes et supportent personnellement, chacun(e) en ce qui les concerne, la totalité de leurs charges fiscales et sociales afférentes au dit remplacement."
  );
  pdf.moveDown(2);
  pdf.text(
    "Article 7\n" +
      "Mme / Mr  " +
      _.titleize(remplacant.nom) +
      " percoit l'ensemble des honoraires correspondant aux actes effectués sur les patients à qui elle / il a donné ses soins.  " +
      "Elle / il doit remplir les obligations comptables normales et habituelles qui lui sont imposées réglementairement.\nEn fin de remplacement, la docteure / le docteur  " +
      nomCompletTitulaire +
      " reverse à  Mme / Mr  " +
      _.titleize(remplacant.nom)
  );

  renderRemuneration(pdf);
  pdf.moveDown(1);
  pdf.text(
    "En cas de participation, au cours du remplacement, à la permanence des soins ambulatoire,le montant de la remunération d'astreinte est du à Mme / Mr  "  +
      _.titleize(remplacant.nom) +
      " qui a exécuté la/les gardes."
  )
  pdf.moveDown(1);
  pdf.text(
    "Conformément aux dispositions de l'article R4127-66 du code de la santé publique (code de déontologie), le remplacement terminé, Madame  / Monsieur "+   _.titleize(remplacant.nom)  +"doit cesser toute activité s'y rapportant et transmettre les informations nécessaires à la continuité des soins."
    )
  pdf.moveDown(1);
  pdf.text(
    "Article 8 : Sans objet."
  );
    pdf.moveDown(1);
  pdf.text(
    "Article 9 : Conciliation\nTous les litiges ou différends relatifs notamment à la validité, l’interprétation, l’exécution ou la résolution du présent contrat, sont soumis avant tout recours à une conciliation confiée au Conseil départemental de l’Ordre des médecins, en application de l’article R.4127-56 du code de la santé publique (code de déontologie médicale)."
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 10 : Arbitrage\nEn cas d’échec de la conciliation, les litiges ou différents relatifs à la validité, l’interprétation, l’exécution ou la résolution du présent contrat, seront soumis à l’arbitrage conformément au règlement d’arbitrage de la Chambre nationale d’Arbitrage des médecins."
  );
  pdf.text(
    "\nDès à présent, les parties conviennent de soumettre leur litige à trois arbitres désignés selon les modalités définies à l’article 4 du règlement d’arbitrage de la Chambre nationale d’Arbitrage des médecins.\nLe tribunal arbitral statuera avec les pouvoirs d’amiable compositeur.\nLes parties renoncent à la possibilité de faire appel.\nLe siège de la Chambre nationale d’Arbitrage des médecins est fixé à PARIS 17, 14 rue Léon Jost."
  );
  pdf.moveDown(1);
  pdf.text(
    "Article 11\nLes parties affirment sur l'honneur n'avoir passé aucune contre-lettre ou avenant relatif au présent contrat qui ne soit soumis au Conseil départemental.\n\nArticle 12\nConformément aux dispositions des articles R.4127-65 (code de déontologie), ce contrat sera communiqué, avant le début du remplacement, par la docteure / le docteur " + _.titleize(titulaire.nom) + "  au Conseil départemental au tableau duquel il/elle est inscrit et par Mme / Mr " + _.titleize(remplacant.nom) + "au Conseil départemental auprés duquel il/elle est enregistré."
  );
  pdf.text(
    "Son renouvellement sera soumis à ces mêmes dispositions.\n\nFait en trois exemplaires\n(dont un pour le Conseil départemental)\nle " +
      moment(contrat.createdAt).format("DD/MM/YYYY") +
      "\nLa docteure / le docteur  " +
      nomCompletTitulaire +
      "                                         " +
      "Madame / Monsieur  " +
      _.titleize(remplacant.nom)
  );
  pdf.addPage();
  pdf.text(
    "Cabinet d'Anesthésie des Cèdres\n48 avenue de Grugliasco\n38130 Echirolles\n04 56 58 12 50",
    40,
    40,
    { align: "left" }
  );
  pdf.text(
    "Echirolles, le " + moment(contrat.createdAt).format("DD/MM/YYYY") + ",",
    340,
    140
  );
  pdf.moveDown(4);
  pdf.text(
    "Conseil de l'Ordre des Médecins\n1A boulevard de la Chantourne\n38700 La Tronche",
    { align: "left" }
  );
  //
  pdf.moveDown(2);
  pdf.text("Monsieur le Président,", 40);
  pdf.moveDown(1);
  pdf.text(
    "Je sollicite de votre haute bienveillance l'autorisation d'être remplacé\n  - par  " +
      _.capitalize(remplacant.salutation) +
      "   " +
      _.titleize(remplacant.fullName) +
      " \n - pour les jours suivants " +
      contrat.setDatesFields +
      " \n\n ",
    40
  );
  pdf.text(
    "Merci de faire le retour de l'autorisation de remplacement par mail à l'adresse suivante:\nsecret.anesthesie@cliniquedescedres.com",
    40
  );
  pdf.moveDown(2);
  pdf.text(
    "Je vous remercie et vous prie de croire, Monsieur, en l'expression de mes salutations distinguées.",
    40
  );
  pdf.moveDown(1);
  pdf.text("Docteur  " + titleize(titulaire.fullName) + "    ", 40);
  //     #renseignements Branchet
  pdf.addPage();
  newBranchet(pdf, titulaire, remplacant, contrat);
  pdf.end();
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/ContratEtudiant.js